[
  {
    "code": "IT-65",
    "name": "Abruzzo"
  },
  {
    "code": "IT-77",
    "name": "Basilicata"
  },
  {
    "code": "IT-78",
    "name": "Calabria"
  },
  {
    "code": "IT-72",
    "name": "Campania"
  },
  {
    "code": "IT-45",
    "name": "Emilia-Romagna"
  },
  {
    "code": "IT-36",
    "name": "Friuli-Venezia Giulia"
  },
  {
    "code": "IT-62",
    "name": "Lazio"
  },
  {
    "code": "IT-42",
    "name": "Liguria"
  },
  {
    "code": "IT-25",
    "name": "Lombardia"
  },
  {
    "code": "IT-57",
    "name": "Marche"
  },
  {
    "code": "IT-67",
    "name": "Molise"
  },
  {
    "code": "IT-21",
    "name": "Piemonte"
  },
  {
    "code": "IT-75",
    "name": "Puglia"
  },
  {
    "code": "IT-88",
    "name": "Sardegna"
  },
  {
    "code": "IT-82",
    "name": "Sicilia"
  },
  {
    "code": "IT-52",
    "name": "Toscana"
  },
  {
    "code": "IT-32",
    "name": "Trentino-Alto Adige"
  },
  {
    "code": "IT-55",
    "name": "Umbria"
  },
  {
    "code": "IT-23",
    "name": "Valle d'Aosta"
  },
  {
    "code": "IT-34",
    "name": "Veneto"
  }
]